// extracted by mini-css-extract-plugin
export default {"container":"AsciiGizmo_container__997CC","asciiGizmo":"AsciiGizmo_asciiGizmo__KwX8p"};